import React, { Component } from 'react';
import { AlbumDetailStyle } from './detailComp';
import { getCookie, baiduStatistics, getQueryString } from 'utils';
import { global } from 'config';
import request from 'utils/request';
import { message } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import $ from 'jquery';

export default class AlbumDetail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            mask: false
        }
    }

    componentDidMount() {
        baiduStatistics();

        $('html').scrollTop(0);

        this.requestList();
    }

    // 主播入口
    goPlatform = () => {
        const { push } = this.props.history;
        let token = getCookie('token');

        if (token) {
            push('/platform');
        } else {
            push('/login');
        }
    }

    changeMask = () => {
        const { mask } = this.state;

        this.setState({
            mask: !mask
        });
    }

    // 获取专辑节目信息
    requestList = () => {
        request({
            url: 'huhuapi/anchor/cateStoryListManager',
            // method: 'post',
            data: {
                cate_id: getQueryString('id'),
                os: 'pc'
            }
        }).then(res => {
            // console.log(res.data);
            if (res.data.status) {
                this.setState({
                    data: res.data.data.story,
                    StoryCate: res.data.data.StoryCate,
                });
            } else {
                message.info(res.data.errorStr);
            }
        }).catch(err => console.log(err));
    }

    render() {
        const { mask, StoryCate, data } = this.state;
        const { history: { push } } = this.props;

        return (<AlbumDetailStyle>
            <div className="albumdetail">
                <header className="home-header">
                    <div className="wrapper">
                        <img src={require('images/home/logo.png')} onClick={() => push('/home')} className="home-logo" alt="呼呼收音机" title="首页" />
                        <div className="home-header-right">
                            <div className="entry" onClick={this.goPlatform}>主播入口</div>
                            <div className="down" onClick={this.changeMask}>下载APP</div>
                        </div>
                    </div>
                </header>


                <div className="detail-main">
                    <div className="album">
                        <img alt={StoryCate && StoryCate.name} src={StoryCate && StoryCate.image} className="album-cover" />
                        <div className="album-right">
                            <h1 className="album-title">{StoryCate && StoryCate.name}</h1>
                            <div className="album-intro">{StoryCate && StoryCate.introduction}</div>
                            <div className="album-con">
                                <div className="num">集数：{StoryCate && StoryCate.story_num}集</div>
                                <div className="view">播放量：{StoryCate && StoryCate.views}</div>
                            </div>
                        </div>
                    </div>

                    <div className="pro-list">
                        {Array.isArray(data) ? data.map((item, index) => <div onClick={this.changeMask} className="pro-item" style={{ background: index % 2 === 0 ? 'rgba(248, 249, 251, 1)' : '' }} key={item.id}>
                            <div className="pro">
                                <img className="pro-cover" alt={item.title} src={item.image} />
                                <div className="pro-con">
                                    <h2 className="title">{item.title}</h2>
                                    <div className="time">
                                        <ClockCircleOutlined style={{ width: '14px', height: '14px', color: '#9A9C9B' }} />
                                        <div className="text">{item.duration}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="play">播放</div>
                        </div>) : ''}
                    </div>
                </div>


                <footer className="home-footer">
                    <div className="footer-top">
                        <div className="word1">
                            <span style={{ fontWeight: 'bold', fontSize: '15px' }}>客服联系方式</span><br />
                            <span style={{ fontWeight: 'bold', fontSize: '15px' }}>公众号</span>：呼呼收音机（id：huhustory）<br />
                            {/* <span style={{ fontWeight: 'bold', fontSize: '15px' }}>联系电话</span>：0571-56716607<br /> */}
                            <span style={{ fontWeight: 'bold', fontSize: '15px' }}>邮箱</span>：huhu@hezi.com<br />
                                （工作时间：工作日9:00-18:00）
                            </div>
                        <div className="word2">
                            <a style={{ color: '#fff' }} href={global.href + "simple/user"} target="_blank" alt="用户协议" title="用户协议" rel="noopener noreferrer">用户协议</a><br />
                            <a style={{ color: '#fff' }} href={global.href + "simple/privacy"} target="_blank" alt="隐私协议" title="隐私协议" rel="noopener noreferrer">隐私协议</a><br />
                            <a style={{ color: '#fff' }} href={global.href + "simple/complaint"} target="_blank" alt="版权投诉指引" title="版权投诉指引" rel="noopener noreferrer">版权投诉指引</a><br />
                            举报邮箱：jubao@hezi.com
                            </div>
                        <div className="footer-i" style={{ marginRight: '52px' }}>
                            <img alt="APP下载" src={require('images/home/huhustory.png')} />
                            <div className="text">APP下载</div>
                        </div>
                        <div className="footer-i">
                            <img alt="公众号" src={require('images/home/wxgzh.png')} />
                            <div className="text">公众号</div>
                        </div>

                    </div>
                    <div className="footer-bottom" style={{ marginTop: '43px' }}>
                        <div className="foot-tip" style={{ marginRight: '54px' }}>增值电信业务经营许可证：浙B2-20200237</div>
                        <a href="http://www.beian.miit.gov.cn" target="_blank" className="foot-tip" rel="noopener noreferrer">浙ICP备19051259号-1</a>
                    </div>

                    <div className="footer-bottom" ><div className="foot-tip">杭州叽里咕噜文化传播有限公司© All Rights Reserved. </div></div>
                    <div className="footer-bottom" ><div className="foot-tip">本平台为信息网络存储空间网络服务平台</div></div>
                </footer>
            </div>

            {mask && <div className="mask">
                <div className="mask-dg" onClick={this.changeMask}></div>
                <div className="mask-con">
                    <img alt="" src={require('images/home/ssssss.png')} className="icon" />
                    <img alt="APP下载" src={require('images/home/huhustory.png')} className="down" />
                    <div className="title">扫码下载呼呼收音机收听更多故事</div>
                    <img src={require('images/home/close.png')} className="close" alt="" onClick={this.changeMask} />
                </div>
            </div>}
        </AlbumDetailStyle>);
    }

}